/**
 * Direction Utilities - Shared compass direction conversions
 *
 * SYNC: This module is shared between frontend and backend.
 */

// Compass points in order (16 points)
const COMPASS_POINTS = ['N', 'NNE', 'NE', 'ENE', 'E', 'ESE', 'SE', 'SSE',
                        'S', 'SSW', 'SW', 'WSW', 'W', 'WNW', 'NW', 'NNW'];

// Wind direction data with degrees and full names
const WIND_DIRECTIONS = {
    'N':   { degrees: 0,     name: 'North' },
    'NNE': { degrees: 22.5,  name: 'North-Northeast' },
    'NE':  { degrees: 45,    name: 'Northeast' },
    'ENE': { degrees: 67.5,  name: 'East-Northeast' },
    'E':   { degrees: 90,    name: 'East' },
    'ESE': { degrees: 112.5, name: 'East-Southeast' },
    'SE':  { degrees: 135,   name: 'Southeast' },
    'SSE': { degrees: 157.5, name: 'South-Southeast' },
    'S':   { degrees: 180,   name: 'South' },
    'SSW': { degrees: 202.5, name: 'South-Southwest' },
    'SW':  { degrees: 225,   name: 'Southwest' },
    'WSW': { degrees: 247.5, name: 'West-Southwest' },
    'W':   { degrees: 270,   name: 'West' },
    'WNW': { degrees: 292.5, name: 'West-Northwest' },
    'NW':  { degrees: 315,   name: 'Northwest' },
    'NNW': { degrees: 337.5, name: 'North-Northwest' }
};

/**
 * Convert degrees to compass direction (cardinal point)
 * @param {number|null} degrees - Direction in degrees (0-360)
 * @returns {string} Compass direction (e.g., 'NNE', 'SW') or empty string if null
 */
export function degreesToCompass(degrees) {
    if (degrees === null || degrees === undefined) return '';
    const index = Math.round(degrees / 22.5) % 16;
    return COMPASS_POINTS[index];
}

/**
 * Convert compass direction abbreviation to degrees
 * @param {string} direction - Compass direction (e.g., 'N', 'NNE')
 * @returns {number} Degrees (0-360) or 0 if not found
 */
export function compassToDegrees(direction) {
    return WIND_DIRECTIONS[direction]?.degrees ?? 0;
}

/**
 * Get full wind direction name from abbreviation
 * @param {string} abbr - Compass direction abbreviation (e.g., 'N', 'NNE')
 * @returns {string} Full name (e.g., 'North', 'North-Northeast') or the abbreviation if not found
 */
export function getDirectionName(abbr) {
    return WIND_DIRECTIONS[abbr]?.name ?? abbr;
}

// Export constants for direct access if needed
export { COMPASS_POINTS, WIND_DIRECTIONS };
